module.exports = __webpack_public_path__ + "static/img/over.265c9ba4.png";